import { SelectableItem } from "../ProcessingActivity.types";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useTransferBasisQuery(hasPermissions: boolean) {
    const url = "/LegalBasis/getTransferBasis/";
    const transferBasisQuery = useDotLegalQuery<Array<SelectableItem>>(url, {
        enabled: hasPermissions,
    });
    return {
        data: transferBasisQuery.data,
        isLoading: transferBasisQuery.isLoading,
    };
}
